import Vue from 'vue'
import Multiselect from 'vue-multiselect'
// @ts-ignore
import NoSsr from 'vue-no-ssr'
import { SELECT_DEFAULT, SELECT_ROUNDED, SELECT_WHITE } from '@/constants/components/select'

export default Vue.extend<any, any, any, any>({
  name: 'lx-select-newest',
  components: { Multiselect, NoSsr },
  props: {
    defaultOption: Boolean,
    fixed: Boolean,
    selectLabel: String,
    label: String,
    trackBy: String,
    loading: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    native: Boolean,
    placeholder: String,
    errorMsg: String,
    options: Array,
    searchable: Boolean,
    value: Object,
    required: Boolean,
  },
  data() {
    return {
      open: false,
      search: '',
      SELECT_DEFAULT,
      SELECT_ROUNDED,
      SELECT_WHITE,
      item: `<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 1L5 5L9 1" stroke="black" stroke-width="1.5"/>
</svg>`,
    }
  },
  computed: {
    showNative() {
      return this.native && !this.loading && !this.disabled && this.isTabletLx
    },
  },
  watch: {
    value: {
      handler() {
        // Sync native select when value changes (e.g., after translation)
        this.$nextTick(() => {
          if (this.$refs.nativeSelect && this.value) {
            const selectValue = this.getNativeValue()
            if (selectValue) {
              ;(this.$refs.nativeSelect as HTMLSelectElement).value = selectValue
            }
          }
        })
      },
      immediate: true,
    },
  },
  methods: {
    openSelect() {
      this.open = true
      if (this.$refs.select && this.fixed) {
        const rect = this.$refs.select.getBoundingClientRect()
        const top = rect.top + rect.height
        const left = rect.left
        const multiselect = this.$refs.select.querySelector('.multiselect__content-wrapper')
        multiselect.style.top = `${top}px`
        multiselect.style.left = `${left}px`
      }
    },
    onSearchChange(search: string) {
      this.search = search
      this.$emit('search-change', search)
    },
    onInput(selected: any) {
      if (selected?.readOnly) {
        return
      }
      this.$emit('input', selected)
    },
    getNativeValue() {
      if (this.value) {
        // Use trackBy if available for stable identification
        if (this.trackBy) {
          return String(this.value[this.trackBy] || '')
        }
        // Fallback to index
        const index = this.options.findIndex((opt: any) => opt === this.value)
        return index !== -1 ? String(index) : ''
      }
      return ''
    },
    onNativeChange(event: any) {
      const selectedValue = event.target.value

      if (this.trackBy) {
        // Find by trackBy field
        const selected = this.options.find((opt: any) => String(opt[this.trackBy]) === selectedValue)
        if (selected) {
          this.$emit('input', selected)
        }
      } else {
        // Fallback to index
        const index = parseInt(selectedValue, 10)
        if (!isNaN(index) && this.options[index]) {
          this.$emit('input', this.options[index])
        }
      }
    },
  },
})
